import { useSelector } from "react-redux"
import { getAux } from "../../store/features/auxSlice"
import { MyTable } from "../MyTable"

export const TransactionDetailTable = ({ transaction }) => {
  const aux = useSelector(getAux)

  const columns = [
    {
      field: "id",
      headerName: "Id",
      width: 75,
      align: "left",
      render: (params) => (
        <span style={{ fontWeight: 500 }}>{params.row.id}</span>
      ),
    },
    {
      field: "mainGroup",
      headerName: "Grupo",
      width: 50,
      align: "left",
    },
    {
      field: "subgroup",
      headerName: "Subgrupo",
      width: 50,
      align: "left",
    },
    {
      field: "concept",
      headerName: "Concepto",
      width: 50,
      align: "left",
    },
    {
      field: "name",
      headerName: "Descripción",
      width: 300,
      align: "left",
    },
    {
      field: "sincePeriod",
      headerName: "Desde",
      width: 75,
      align: "left",
    },
    {
      field: "untilPeriod",
      headerName: "Hasta",
      width: 75,
      align: "left",
    },
    {
      field: "price",
      headerName: "Precio",
      width: 100,
      align: "right",
      render: (params) => (
        <span style={{ color: params.row.price > 0 ? "green" : "red" }}>
          <span>
            {aux.data.coins.find((item) => item.id === params.row.coin).value}
          </span>{" "}
          <span>{params.row.price.toFixed(2)}</span>
        </span>
      ),
    },
    {
      field: "quantity",
      headerName: "Cantidad",
      width: 50,
      align: "right",
    },
    {
      field: "subtotal",
      headerName: "Importe",
      width: 100,
      align: "right",
      render: (params) => (
        <span style={{ color: params.row.subtotal > 0 ? "green" : "red" }}>
          <span>
            {aux.data.coins.find((item) => item.id === params.row.coin).value}
          </span>{" "}
          <span>{params.row.subtotal.toFixed(2)}</span>
        </span>
      ),
    },
  ]

  return (
    <div style={{ width: "100%", background: "rgba(0,0,0,0.015)" }}>
      <MyTable columns={columns} rows={transaction.detail} />
    </div>
  )
}
